if ( typeof ShippingNotice !== 'function' ) {

  class ShippingNotice extends HTMLElement {

    constructor() {
      super();
      this.lastCartTotal = null;
      this.isUpdating = false;
      this.updateTimeout = null;
      this.bound = false;
      this.init();
      this.setupEventListeners();
    }

    init() {
      this.updateShippingNotice();
    }

    setupEventListeners() {
      // Attach listener to cart form
      this.attachCartFormListener = () => {
        const cartForm = document.getElementById('AjaxCartForm');
        if (cartForm) {
          // Remove old listener if exists
          if (this.cartFormRef) {
            this.cartFormRef.removeEventListener('cart-updated', this.handleUpdate);
          }
          
          // Create bound update handler
          this.handleUpdate = () => {
            setTimeout(() => this.fetchUpdatedCartData(), 100);
            // Re-attach after update (in case cart form was replaced)
            setTimeout(() => this.attachCartFormListener(), 200);
          };
          
          // Attach new listener
          cartForm.addEventListener('cart-updated', this.handleUpdate);
          this.cartFormRef = cartForm;
        }
      };
      
      // Initial attach
      this.attachCartFormListener();
      
      // Keep trying if not found yet
      if (!this.cartFormRef) {
        const checkInterval = setInterval(() => {
          this.attachCartFormListener();
          if (this.cartFormRef) {
            clearInterval(checkInterval);
          }
        }, 100);
        setTimeout(() => clearInterval(checkInterval), 5000);
      }
      
      // Also listen for document-level custom events
      document.addEventListener('cartUpdated', () => {
        setTimeout(() => this.fetchUpdatedCartData(), 100);
      });
    }

    updateAllShippingNotices(cartTotal = null) {
      // Update all shipping-notice elements on the page with the same cart total
      document.querySelectorAll('shipping-notice').forEach(notice => {
        if (notice !== this) {
          // Pass the cart total directly to avoid reading stale DOM values
          if (cartTotal !== null) {
            notice.updateShippingNotice(cartTotal);
          }
        }
      });
    }

    fetchUpdatedCartData() {
      if (this.isUpdating) {
        return; // Prevent multiple simultaneous updates
      }
      
      this.isUpdating = true;
      
      // Get cart total from the cart subtotal element (not the shipping notice)
      let cartTotalElement = document.querySelector('#AjaxCartSubtotal [data-cart-total]');
      
      // If not found, try other selectors
      if (!cartTotalElement) {
        cartTotalElement = document.querySelector('.cart__total[data-cart-total]');
      }
      
      // If still not found, try to get from cart form
      if (!cartTotalElement) {
        cartTotalElement = document.querySelector('#AjaxCartForm [data-cart-total]');
      }
      
      if (cartTotalElement) {
        const cartTotalText = cartTotalElement.textContent || cartTotalElement.innerText;
        // Extract number from formatted currency string
        const cartTotalMatch = cartTotalText.match(/[\d,]+\.?\d*/);
        if (cartTotalMatch) {
          const cartTotal = parseFloat(cartTotalMatch[0].replace(/,/g, '')) * 100; // Convert to cents
          this.updateShippingNotice(cartTotal);
          // Update all other shipping notices with the same cart total
          this.updateAllShippingNotices(cartTotal);
        } else {
          // Fallback to original data
          this.updateShippingNotice();
          this.updateAllShippingNotices();
        }
      } else {
        // Fallback to original data
        this.updateShippingNotice();
        this.updateAllShippingNotices();
      }
      
      // Reset the updating flag after a short delay
      setTimeout(() => {
        this.isUpdating = false;
      }, 100);
    }

    updateShippingNotice(cartTotal = null) {
      const freeShippingThreshold = Math.round(Number(this.getAttribute('data-free-shipping')) * (Shopify.currency.rate ? Number(Shopify.currency.rate) : 1));
      
      // Use provided cart total or fallback to attribute
      if (!cartTotal) {
        cartTotal = Number(this.getAttribute('data-cart-total'));
      }
      
      // Calculate remaining amount needed (threshold - current total)
      const freeShippingRemaining = freeShippingThreshold - cartTotal;
			
      let cartSliderWidth = 0;
      let messageHTML = '';
      
      if ( freeShippingRemaining > 0 ) {
        // Still need to spend more
        const remainingAmount = this._formatMoney(freeShippingRemaining, KROWN.settings.shop_money_format);
        messageHTML = `Spend <span>${remainingAmount}</span> more to unlock <strong>FREE Express Shipping</strong>`;
        cartSliderWidth = 100 - (freeShippingRemaining * 100 / freeShippingThreshold);
      } else {
        // Eligible for free shipping
        messageHTML = `You are eligible for <strong>FREE Express Shipping</strong>!`;
        cartSliderWidth = 100;
      }
      
      // Update this instance
      this.querySelector('[data-js-free-shipping-text]').innerHTML = messageHTML;
			if ( this.querySelector('[data-js-free-shipping-slider]') ) {
				this.querySelector('[data-js-free-shipping-slider]').style.width = `${cartSliderWidth}%`;
			}
      
      // ALWAYS update ALL other shipping notices with the same values
      document.querySelectorAll('shipping-notice').forEach(notice => {
        if (notice !== this) {
          const textElement = notice.querySelector('[data-js-free-shipping-text]');
          if (textElement) {
            textElement.innerHTML = messageHTML;
          }
          const sliderElement = notice.querySelector('[data-js-free-shipping-slider]');
          if (sliderElement) {
            sliderElement.style.width = `${cartSliderWidth}%`;
          }
        }
      });
    }
    
    _formatMoney(cents, format) {

			if (typeof cents === 'string') {
				cents = cents.replace('.', '');
			}
	
			let value = '';
			const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
			const formatString = format || moneyFormat;
	
			function formatWithDelimiters(number, precision, thousands, decimal) {
				thousands = thousands || ',';
				decimal = decimal || '.';
	
				if (isNaN(number) || number === null) {
					return 0;
				}
	
				number = (number / 100.0).toFixed(precision);
	
				const parts = number.split('.');
				const dollarsAmount = parts[0].replace(
					/(\d)(?=(\d\d\d)+(?!\d))/g,
					'$1' + thousands
				);
				const centsAmount = parts[1] ? decimal + parts[1] : '';
	
				return dollarsAmount + centsAmount + KROWN.settings.iso_code;
			}
	
			switch (formatString.match(placeholderRegex)[1]) {
				case 'amount':
					value = formatWithDelimiters(cents, 2);
					break;
				case 'amount_no_decimals':
					value = formatWithDelimiters(cents, 0);
					break;
				case 'amount_with_comma_separator':
					value = formatWithDelimiters(cents, 2, '.', ',');
					break;
				case 'amount_no_decimals_with_comma_separator':
					value = formatWithDelimiters(cents, 0, '.', ',');
					break;
				case 'amount_no_decimals_with_space_separator':
					value = formatWithDelimiters(cents, 0, ' ');
					break;
				case 'amount_with_apostrophe_separator':
					value = formatWithDelimiters(cents, 2, "'");
					break;
			}
	
			return formatString.replace(placeholderRegex, value);
	
		}

  } 

  if ( typeof customElements.get('shipping-notice') == 'undefined' ) {
    customElements.define('shipping-notice', ShippingNotice);
  }

}